export default "__VITE_ASSET__a229169e__"